import { isObjectTypeId } from 'customer-data-objects/constants/ObjectTypeIds';

/**
 * See backend MetaTypeProto for full list of CrmObject type prefixes
 * https://git.hubteam.com/HubSpotProtected/CrmObjects/blob/master/CrmObjectsBase/src/main/proto/hubspot/crm/objects/crmobjects-core.proto#L414
 *
 */

const isPortalSpecificObjectType = (objectType = '') => isObjectTypeId(objectType) && objectType.startsWith('2-');
export default isPortalSpecificObjectType;